export default "__VITE_ASSET__BzoxUq2p__"